import { useQuery } from '@tanstack/react-query';
import { BotAccessResponse } from '../../../types/bot-access/BotAccessResponse';
import { getBotAccess } from '../../../services/bot-access/BotAccessService';
import { GET_BOT_ACCESS } from '../../query/bot-access/keys';

export const useGetBotAccess = (projectId: number | null) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, refetch, isError } = useQuery<BotAccessResponse>({
    queryKey: [GET_BOT_ACCESS, projectId],
    queryFn: () => getBotAccess(projectId!),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
